<template>
  <div class="header smallheader">
    <div class="container">
      <div class="row table-row">
        <div class="col-xs-2 logo">
          <h1>
            <a href="http://wikiallergies.com" target="_blank"><img alt="WikiAllergies"
                                                                    src="/img/logo_s.png"
                                                                    title="WikiAllergies"></a>
          </h1>
        </div>
        <div class="col-xs-10 menu"><!--Menu after logged in-->
          <ul v-if="$route.name !== 'login'" class="mainmenu">
            <li v-if="$store.state.user.fullName && $store.state.authenticated && $route.name !== 'login'"
                class="top-filter">
              <div :style="{ backgroundImage: 'url(https://wikiallergies.com' + $store.state.user.avatar + ')' }"
                   class="avatar"></div>
              {{ $store.state.user.fullName }}
            </li>

            <li v-if="$store.state.authenticated"><a href="javascript:void(0)" @click="logout()">Log Out</a></li>

            <li v-if="$store.state.authenticated" class="fullscreen-trigger" title="Fullscreen mode"
                @click="toggleFullScreen"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from './../client'
import store from '../store/store'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'TopMenu',
  mixins: [],
  data () {
    return {
      isFullScreen: this.$store.state.isFullScreen,
      internalTime: null,
      dateNow: moment(),
    }
  },

  methods: {
    time () {
      this.dateNow = moment()
    },

    checkShowStaff (staff) {
      //        if(this.selectedLocation) {
      //          let index = this.locations.findIndex(l => l._id == this.selectedLocation)
      //          if(index > -1) {
      //            if(staff.idWiki === this.locations[index].staffIdWiki) {
      //              return true
      //            }
      //          }
      //        }
      //        return false
      return (staff.email !== 'g8tuananh@gmail.com')
    },
    checkShowLocation (location) {
      return true
    },
    changeStaff (staff) {
      if (staff == '') {
        this.selectedStaff = ''
      } else {
        this.selectedStaff = staff._id
        // let indexLocation = this.locations.findIndex(s => s.clinicIdWiki === staff.clinicIdWiki)
        // if (indexLocation > -1) {
        // 	this.selectedLocation = this.locations[indexLocation]._id
        // }
      }
    },
    changeLocation (location) {
      // set object location
      if (location == '') {
        this.selectedLocation = ''
        this.$store.commit('setLocationObject', null)
      }
      if (location._id) {
        this.selectedLocation = location._id
        this.$store.commit('setLocationObject', location)
      }
    },
    logout: function () {
      axios.get('/logout').then()
      this.isFullScreen = false
      document.body.className = ''
      if (store.state.timeOutLogin) {
        clearTimeout(store.state.timeOutLogin)
      }
      this.$router.replace({ name: 'login' })
    },
    toggleFullScreen: function () {
      this.isFullScreen = !this.isFullScreen
      this.$store.commit('setFullScreen', this.isFullScreen)
      document.body.className = this.isFullScreen ? 'fullscreen' : ''
    }

  },
  mounted () {
    this.locations = this.$store.getters.locations
    this.staffs = this.$store.getters.staffs
    this.selectedLocation = this.$store.getters.selectedLocation
    this.selectedStaff = this.$store.getters.selectedStaff
    this.numberTaskNotResolve = this.$store.getters.numberNotResolved
    this.numberPatientCommunicationNotResolve = this.$store.getters.numberPatientCommunicationNotResolve
  },
  watch: {
    storeLocations: {
      handler: function (newVal, oldVal) {
        this.locations = newVal
        if (this.storeSettingMode) {
          if (newVal.length) {
            this.selectedLocation = newVal[0]._id
            this.$store.commit('setLocationObject', newVal[0])
          }
        }
      },
      deep: true
    },
    storeSettingMode: { // update select location after change setting
      handler: function (newVal, oldVal) {
        if (newVal) {
          if (this.locations.length) {
            if (this.selectedLocation.toString() !== this.locations[0]._id.toString()) {
              this.selectedLocation = this.locations[0]._id
              this.$store.commit('setLocationObject', this.locations[0])
            }
          }
        }
      },
      deep: true
    },
    storeStaffs: {
      handler: function (newVal, oldVal) {
        this.staffs = newVal
      },
      deep: true
    },
    storeSelectedLocation (newVal, oldVal) {
      if (newVal !== this.selectedLocation) {
        this.selectedLocation = newVal
      }
    },
    storeIsFullScreen (newVal, oldVal) {
      this.isFullScreen = newVal
    },
    storeSelectedStaff (newVal, oldVal) {
      if (newVal !== this.selectedStaff) {
        this.selectedStaff = newVal
      }
    },
    selectedLocation (newVal, oldVal) {
      if (newVal !== this.storeSelectedLocation) {
        this.$store.commit('setSelectedLocation', newVal)
      }
    },
    selectedStaff (newVal, oldVal) {
      if (newVal !== this.storeSelectedStaff) {
        this.$store.commit('setSelectedStaff', newVal)
      }
    },
    storeNumberNotResolved (newVal, oldVal) {
      this.numberTaskNotResolve = newVal < newVal ? 0 : newVal
    },
    storeNumberPatientCommunicationNotResolved (newVal, oldVal) {
      this.numberPatientCommunicationNotResolve = newVal < newVal ? 0 : newVal
    }
  },
  computed: {
    ...mapGetters({
      storeLocations: 'locations',
      storeStaffs: 'staffs',
      storeSelectedLocation: 'selectedLocation',
      storeSelectedStaff: 'selectedStaff',
      storeSettingMode: 'settingMode',
      storeIsFullScreen: 'isFullScreen',

    }),
  },
  beforeDestroy () {
    if (this.internalTime) {
      clearInterval(this.internalTime)
    }
  }
}
</script>

<style scoped>
.box-select-header {
  padding-top: 5px;
}

.top-filter {
  border-left: none !important;
  border-right: 1px solid #e1e1e1;
}

.icon-bell {
  display: inline-block;
}

.icon-bell:before {
  content: "\f0f3" !important;
  font-family: "Font Awesome\ 5 Free";
  margin-right: 5px;
  color: #898989;
  font-size: 1.2em;
  line-height: 1em;
}

.number-task {
  font-size: 10px;
  position: absolute;
  top: 2px;
  right: 5px;
  padding: 2px 6px;
  border-radius: 50%;
  background: red;
  color: white;
}

.no-number:before {
  content: "\F0F3" !important;
  font-family: "Font Awesome\ 5 Free";
  font-weight: 900;
  margin-right: 5px;
  color: #efefef;
  font-size: 1.2em;
  line-height: 1em;
}
</style>
